import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
`
export const Item = styled.span`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  font-weight: 400;
`

export const LabelSpan = styled.span`
  color: ${props => props.theme.colors.neutral.medium};
`

export const QuantityItemValue = styled.span`
  color: ${props => props.theme.colors.primary};
  font-weight: 400;
`

export const QuantityCutItemsValue = styled.span`
  color: ${props => props.theme.colors.suport.error};
  font-weight: 400;
`
